import { FC } from 'react';
import { AvatarGroup } from '@fe-learner-common';
import { useIntl } from 'react-intl';

type InstructorsPromoProps = {
  visiblePersons: { name: string; thumbnail: string }[];
  totalPersons: number;
};

export const InstructorsPromo: FC<InstructorsPromoProps> = ({
  visiblePersons,
  totalPersons,
}) => {
  const intl = useIntl();
  const diff = totalPersons - visiblePersons.length;
  const names = visiblePersons.map(({ name }, index) => (
    <span key={`instructor-${index}`} className="text-nowrap px-1">
      {name}
      {index !== visiblePersons.length - 1 || diff > 0 ? ',' : null}
    </span>
  ));

  return (
    <div className="flex items-center gap-x-3">
      <AvatarGroup
        size="md"
        users={visiblePersons.map(({ name, thumbnail }) => ({
          src: thumbnail,
          alt: name,
        }))}
      />
      <div>
        <p className="px-1 text-body-sm text-neutral-500">
          {intl.formatMessage(
            { id: 'learner.common.instructors.count' },
            { count: totalPersons },
          )}
          :
        </p>
        <div className="inline-flex flex-wrap text-label-md">
          {names}
          {diff > 0 && (
            <span className="px-1 py-0.5">
              +
              {intl.formatMessage(
                { id: 'learner.common.more.count' },
                { count: diff },
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
